class CartCount extends HTMLElement {
  constructor() {
    super();

    this.updateCount();

    document.addEventListener("addtocart", () => {
      this.updateCount();
    });

    document.addEventListener("cart:change", (event) => {
      this.setCount(event.detail.item_count);
    });
  }

  setCount(count) {
    const total = Number(count) || 0;
    this.textContent = total;
    this.toggleAttribute("hidden", total === 0);
  }

  updateCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        this.setCount(cart.item_count);
      });
  }
}

customElements.define("component-cart-count", CartCount);
